import router from "./router";
import storage from "./components/tools/storage";

router.beforeEach(async (to, from, next) => {
  const userInfo = storage.getUserInfo()
  if (userInfo) {
    const types = storage.getBusinessTypes()
    if (hasPermission(types, to,userInfo.userType)) {
      next()
    } else {
      next('/401')
    }
  } else {
    next()
  }
})

function hasPermission(types, route,userType) {
  if (route.meta && route.meta.type) {
      if(userType === 'student') {
          return true;
      } else {
          return types.some(type => route.meta.type === type)
      }
  }else {
    return true
  }
}



// WEBPACK FOOTER //
// ./src/permission.js